import {ConnectionListProps} from './types';
import {H4} from '@quarks';
import {TwoColumnCell} from '@atoms';
import {Avatar} from '../Avatar';

export const ConnectionList = ({connections, separator = false, title}: ConnectionListProps) => {
  if (!connections.length) return <></>;

  return (
    <>
      {separator && <hr />}

      {title && <H4>{title}</H4>}

      {connections.map((connection) => {
        return (
          <TwoColumnCell
            key={`connection-${connection.id}`}
            padding="small"
            separator={false}
            left={<Avatar user={connection} />}
            right={<p>{connection.name || connection.email}</p>}
          />
        );
      })}
    </>
  );
};
